export const Leave = () => import("./Leave.vue");
export const Chart = () => import("./Chart.vue");
export const Dashboard = () => import("./Dashboard.vue");
export const PlanLeave = () => import("./PlanLeave.vue");
export const LeaveChart = () => import("./LeaveChart.vue");
export const LeaveStatus = () => import("./LeaveStatus.vue");
export const LeavePresentDetails = () => import("./LeavePresentDetails.vue");
export const LeaveAbsentDetails = () => import("./LeaveAbsentDetails.vue");
export const AvailedLeave = () => import("./AvailedLeave.vue");
export const LastLeaveAvailed = () => import("./LastLeaveAvailed.vue");
export const LastLeaveAvailedOfficer = () => import("./LastLeaveAvailedOfficer.vue");
export const PlanLeaveDetails = () => import("./PlanLeaveDetails.vue");
export const LeaveCompanyStatus = () => import("./LeaveCompanyStatus.vue");
export const AvailedSummaryLeave = () => import("./AvailedSummaryLeave.vue");
export const AvailedLeaveMonthly = () => import("./AvailedLeaveMonthly.vue");
export const AvailedLeaveUserDetails = () => import("./AvailedLeaveUserDetails.vue");
export const LeaveDeviationDetails = () => import("./LeaveDeviationDetails.vue");
